import {Buffer as $hgUW1$Buffer} from "buffer";
import {v4 as $hgUW1$v4} from "uuid";
import {DeepstreamClient as $hgUW1$DeepstreamClient} from "@deepstream/client";
import {CONNECTION_STATE as $hgUW1$CONNECTION_STATE} from "@deepstream/client/dist/src/constants";


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $b7e00d9222920261$exports = {};
var $3e7eb75c2c460d38$exports = {};

$parcel$export($3e7eb75c2c460d38$exports, "CenoraInternalCommunication", () => $3e7eb75c2c460d38$export$4835bcdedd18ae83);
const $3587fdc56add8044$export$729b75f63381f542 = [
    "click",
    "message",
    "filter",
    "dragAndDrop",
    "error",
    "search"
];
const $3587fdc56add8044$export$3f998edc3c1ec152 = [
    "parent",
    "child"
];








const $62472a739c57a706$export$ce6407483501daba = (x)=>(0, $3587fdc56add8044$export$729b75f63381f542).includes(x);
const $62472a739c57a706$export$e4d0cda546632cbb = (x)=>(0, $3587fdc56add8044$export$3f998edc3c1ec152).includes(x);
const $62472a739c57a706$export$a13c5582481c8c31 = (x)=>{
    if (typeof x === "object" && x !== null || Array.isArray(x)) return true;
    if (typeof x === "string" || typeof x === "number" || typeof x === "boolean") return true;
    return false;
};
const $62472a739c57a706$export$b27ccd6cf6073c1c = (x)=>{
    if (!x || typeof x !== "object") return false;
    if (!$62472a739c57a706$export$ce6407483501daba(x.type)) return false;
    if (!$62472a739c57a706$export$a13c5582481c8c31(x.data)) return false;
    if (typeof x.name !== "string") return false;
    return true;
};


const $9b317e604428ac1f$var$BasicEventOptions = [
    {
        name: "basic-click-event",
        event: "click"
    },
    {
        name: "basic-unauthorized-event",
        event: "error"
    }
];
const $9b317e604428ac1f$export$ea39325dfd4948c = (x)=>$9b317e604428ac1f$var$BasicEventOptions.some((o)=>o.name === x.name && o.event === x.event);





var $e187dc374e97bf74$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $e187dc374e97bf74$export$3291343375ee8b92 {
    constructor(eventSender, { emitEmptyCallback: emitEmptyCallback = true } = {}){
        this.listeners = [];
        this.eventSender = eventSender;
        this.emitEmptyCallback = emitEmptyCallback;
    }
    init(listeners) {
        return $e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
            const UUIds = [];
            for (const listener of listeners){
                this.validateParams(listener.event, listener.callback);
                const UUId = yield this.addListener(listener.event, listener.name, listener.callback);
                UUIds.push(UUId);
            }
            return UUIds;
        });
    }
    subscribe() {
        window.removeEventListener("message", this.broadcastEvent.bind(this));
        if (!this.listeners.length) return;
        window.addEventListener("message", this.broadcastEvent.bind(this));
    }
    broadcastEvent(event) {
        return $e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
            if (!(0, $62472a739c57a706$export$b27ccd6cf6073c1c)(event.data)) return;
            const filteredListeners = this.listeners.filter((listener)=>listener.event === event.data.type && listener.name === event.data.name).map((listener)=>$e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
                    if (event.data.contentType === "json") {
                        yield listener.callback(Object.assign(Object.assign({}, event.data), {
                            data: JSON.parse(event.data.data)
                        }));
                        return;
                    }
                    yield listener.callback(event.data);
                }));
            if (!filteredListeners.length && this.emitEmptyCallback) {
                yield this.autoEmitEmptyCallback(event.data);
                return;
            }
            yield Promise.all(filteredListeners);
        });
    }
    autoEmitEmptyCallback(event) {
        return $e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
            return yield new Promise((resolve)=>{
                const data = event.contentType === "json" ? JSON.parse(event.data) : event.data;
                if (event.type === "message" && event.name === "logout") this.eventSender.sendMessage(data.callbackEvent.type, data.callbackEvent.name, data.callbackEvent.callbackMessage);
                resolve("");
            });
        });
    }
    validateParams(event, callback) {
        if (!(0, $62472a739c57a706$export$ce6407483501daba)(event)) throw new Error("Event must be a valid EventSenderType");
        if (typeof callback !== "function") throw new Error("Callback must be a function");
        if (callback.length > 1) throw new Error("Callback must have no more than 1 parameter and typeof IEventSenderMessage");
    }
    createUUId() {
        return $e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
            return yield new Promise((resolve)=>{
                let id;
                while(!id){
                    const temp = (0, $hgUW1$v4)();
                    if (!this.listeners.some((l)=>l.uuid === temp)) id = temp;
                }
                resolve(id);
            });
        });
    }
    addOneTimeEventListener(listener) {
        return $e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
            this.validateParams(listener.event, listener.callback);
            if (this.listeners.some((l)=>l.name === listener.name && l.event === listener.event)) yield new Promise((resolve)=>{
                this.listeners = this.listeners.filter((l)=>l.name !== listener.name && l.event !== listener.event);
                resolve(true);
            });
            const ref = this.addListener(listener.event, listener.name, (e)=>$e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.removeListener(e.type, e.name);
                    listener.callback(e);
                }));
            return ref;
        });
    }
    addListener(event, name, callback) {
        return $e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
            if (this.listeners.some((l)=>l.name === name && l.event === event)) throw new Error(`Listener with name ${name} and event ${event} already exists.`);
            this.validateParams(event, callback);
            const UUId = yield this.createUUId();
            this.listeners.push({
                event: event,
                name: name,
                uuid: UUId,
                callback: callback
            });
            return {
                name: name,
                uuid: UUId
            };
        });
    }
    removeListener(eventType, name) {
        return $e187dc374e97bf74$var$__awaiter(this, void 0, void 0, function*() {
            yield new Promise((resolve)=>{
                this.listeners = this.listeners.filter((l)=>{
                    if (l.name === name && l.event === eventType) return false;
                    return true;
                });
                resolve(true);
            });
        });
    }
    removeAllListeners() {
        this.listeners = [];
    }
}



class $4d92c050867b827e$export$142dcb3ca8a5e271 {
    sendMessage(type, name, data, options) {
        if (!name) throw new Error("Name is required to send message");
        if (!(0, $62472a739c57a706$export$ce6407483501daba)(type)) throw new Error("Type must be a valid EventSenderType");
        if (!(0, $62472a739c57a706$export$a13c5582481c8c31)(data)) throw new Error("Data type must be a valid EventSenderDataType");
        if (typeof data === "object" || Array.isArray(data)) {
            this.send({
                type: type,
                name: name,
                contentType: "json",
                data: JSON.stringify(data)
            }, options);
            return;
        }
        if (typeof data === "string" || typeof data === "number" || typeof data === "boolean") this.send({
            type: type,
            name: name,
            contentType: "simple",
            data: data
        }, options);
    }
    send(data, { to: to = "parent", target: target } = {}) {
        if (!(0, $62472a739c57a706$export$e4d0cda546632cbb)(to)) throw new Error("To must be a valid EventSenderToType");
        if (to === "child") {
            if (!target) throw new Error("Target is required when sending message to child");
            try {
                target.postMessage(data, "*");
            } catch (error) {
                console.log("Error sending message");
                console.log(error);
            }
            return;
        }
        try {
            window.parent.postMessage(data, "*");
        } catch (error) {
            console.log("Error sending message");
            console.log(error);
        }
    }
}





var $3e7eb75c2c460d38$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $3e7eb75c2c460d38$export$4835bcdedd18ae83 {
    static init(listeners = [], { emitBasicEvents: emitBasicEvents = true, basicEventConfig: basicEventConfig, subscribeForBasicEvents: subscribeForBasicEvents = false, basicEventSubscribeListeners: basicEventSubscribeListeners = [], emitEmptyCallback: emitEmptyCallback } = {}) {
        return $3e7eb75c2c460d38$var$__awaiter(this, void 0, void 0, function*() {
            this.eventSenderInstance = new (0, $4d92c050867b827e$export$142dcb3ca8a5e271)();
            if (emitBasicEvents) this.emitBasicEvents(basicEventConfig);
            const l = !listeners ? [] : listeners;
            if (subscribeForBasicEvents) {
                if (basicEventSubscribeListeners.length) for (const listener of basicEventSubscribeListeners){
                    if (!(0, $9b317e604428ac1f$export$ea39325dfd4948c)(listener)) throw new Error(`Invalid basic event name: ${listener.name}. Go to BasicEventNameType for more information.`);
                    const match = this.basicEventListeners.find((el)=>el.event === listener.event && el.name === listener.name);
                    match.callback = listener.callback;
                }
                l.push(...this.basicEventListeners);
            }
            if (l.length !== new Set(l.map((listener)=>JSON.stringify({
                    name: listener.name,
                    event: listener.event
                }))).size) {
                const duplicatedNames = l.filter((listener)=>l.filter((el)=>el.name === listener.name && el.event === listener.event).length > 1).map((listener)=>JSON.stringify({
                        name: listener.name,
                        event: listener.event
                    })).join(", ");
                throw new Error(`Duplicated event listeners: ${duplicatedNames}.\nEach event listener must have a unique name and event.`);
            }
            this.eventListenerInstance = new (0, $e187dc374e97bf74$export$3291343375ee8b92)(this.eventSenderInstance, {
                emitEmptyCallback: emitEmptyCallback
            });
            yield this.eventListenerInstance.init(l);
            this.eventListenerInstance.subscribe();
        });
    }
    static emitBasicEvents(basicEventConfig) {
        this.removeBasicEventListeners();
        window.document.body.addEventListener("click", this.sendClickEvent.bind(this));
        if (basicEventConfig === null || basicEventConfig === void 0 ? void 0 : basicEventConfig.axios) {
            const unauthorizedStatuses = [
                403,
                401
            ];
            basicEventConfig.axios.interceptors.response.use((data)=>data, (err)=>$3e7eb75c2c460d38$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b;
                    const error = (_a = err.response) !== null && _a !== void 0 ? _a : err;
                    if (unauthorizedStatuses.includes((_b = error === null || error === void 0 ? void 0 : error.data) === null || _b === void 0 ? void 0 : _b.status) || unauthorizedStatuses.includes(error.status) || error.statusText === "Unauthorized") this.eventSenderInstance.sendMessage("error", "basic-unauthorized-event", true);
                    return err;
                }));
        }
    }
    static sendClickEvent() {
        this.eventSenderInstance.sendMessage("click", "basic-click-event", "click");
    }
    static removeBasicEventListeners() {
        window.document.body.removeEventListener("click", this.sendClickEvent);
    }
    static get eventListener() {
        if (!this.eventListenerInstance) throw new Error("You must call init() before accessing eventListener");
        return this.eventListenerInstance;
    }
    static get eventSender() {
        if (!this.eventSenderInstance) throw new Error("You must call init() before accessing eventListener");
        return this.eventSenderInstance;
    }
}
$3e7eb75c2c460d38$export$4835bcdedd18ae83.basicEventListeners = [
    {
        event: "click",
        name: "basic-click-event",
        callback: ()=>{}
    },
    {
        event: "error",
        name: "basic-unauthorized-event",
        callback: ()=>{}
    }
];


var $263e32773babf6b0$exports = {};

$parcel$export($263e32773babf6b0$exports, "CenoraRealtimeCommunication", () => $263e32773babf6b0$export$a0a76643dec233ef);

var $4cd3b7212bcaccc8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $4cd3b7212bcaccc8$export$d85660bfa2d43d55 {
    constructor(client){
        this.client = client;
    }
    subscribeToEvent(eventName, callback) {
        return $4cd3b7212bcaccc8$var$__awaiter(this, void 0, void 0, function*() {
            this.client.event.subscribe(eventName, callback);
        });
    }
    sendEventData(eventName, data) {
        return $4cd3b7212bcaccc8$var$__awaiter(this, void 0, void 0, function*() {
            this.client.event.emit(eventName, data);
        });
    }
    unsubscribeFromEvent(eventName, callback) {
        return $4cd3b7212bcaccc8$var$__awaiter(this, void 0, void 0, function*() {
            this.client.event.unsubscribe(eventName, callback);
        });
    }
}


var $917eb34e2ff5fad2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $917eb34e2ff5fad2$export$3da1b1fa9b85532a {
    constructor(client){
        this.client = client;
    }
    getRecordInstance(name) {
        return $917eb34e2ff5fad2$var$__awaiter(this, void 0, void 0, function*() {
            if (this.record) return this.record;
            this.record = this.client.record.getRecord(name);
            yield this.record.whenReady();
            return this.record;
        });
    }
    subscribeToMeeting(name, callback, objectPath) {
        return $917eb34e2ff5fad2$var$__awaiter(this, void 0, void 0, function*() {
            const record = yield this.getRecordInstance(name);
            if (objectPath) {
                record.subscribe(objectPath, callback);
                return;
            }
            record.subscribe(callback);
        });
    }
    sendMeetingData(name, data, objectPath) {
        return $917eb34e2ff5fad2$var$__awaiter(this, void 0, void 0, function*() {
            const record = yield this.getRecordInstance(name);
            if (objectPath) {
                record.set(objectPath, data);
                return;
            }
            record.set(data);
        });
    }
    getMeetingData(name, objectPath) {
        return $917eb34e2ff5fad2$var$__awaiter(this, void 0, void 0, function*() {
            const record = yield this.getRecordInstance(name);
            if (objectPath) return record.get(objectPath);
            return record.get();
        });
    }
    endMeeting(name, callback) {
        return $917eb34e2ff5fad2$var$__awaiter(this, void 0, void 0, function*() {
            const record = yield this.getRecordInstance(name);
            record.unsubscribe(callback);
            this.record = null;
        });
    }
    meetingExists(name) {
        return $917eb34e2ff5fad2$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.client.record.has(name);
        });
    }
    meetingStarted(name) {
        return $917eb34e2ff5fad2$var$__awaiter(this, void 0, void 0, function*() {
            const record = yield this.getRecordInstance(name);
            return record.isReady;
        });
    }
}



var $588d53c9d0a3fe05$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $588d53c9d0a3fe05$export$158274cca421e33f {
    constructor(client, config, connectionStateHandler){
        this.client = client;
        this.config = config;
        this.connectionStateHandler = connectionStateHandler;
    }
    init() {
        return $588d53c9d0a3fe05$var$__awaiter(this, void 0, void 0, function*() {
            const connectionState = this.client.getConnectionState();
            if (!this.connectionStateHandler) return;
            if (connectionState !== (0, $hgUW1$CONNECTION_STATE).OPEN) this.connectionStateHandler[connectionState]();
            this.setConnectionStateHandlers();
        });
    }
    setConnectionStateHandlers() {
        return $588d53c9d0a3fe05$var$__awaiter(this, void 0, void 0, function*() {
            this.client.off();
            for(const key in this.connectionStateHandler)this.client.on(key, this.connectionStateHandler[key]);
        });
    }
    send(method, params = {}) {
        var _a;
        return $588d53c9d0a3fe05$var$__awaiter(this, void 0, void 0, function*() {
            if (this.client.getConnectionState() !== (0, $hgUW1$CONNECTION_STATE).OPEN) throw new Error("Connection is not open");
            params.origin = this.config.origin;
            params.token = this.config.token;
            const response = yield this.client.rpc.make(method, params);
            if (response.status !== "success") {
                if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.code) === "InvalidToken") {
                    this.connectionStateHandler.UNAUTHORIZED();
                    return;
                }
                throw response.data;
            }
            return response.data;
        });
    }
    registerCallback(method, callback) {
        this.client.rpc.provide(method, callback);
    }
    unRegisterCallback(method) {
        this.client.rpc.unprovide(method);
    }
    close() {
        return $588d53c9d0a3fe05$var$__awaiter(this, void 0, void 0, function*() {
            this.client.close();
        });
    }
}




var $263e32773babf6b0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $263e32773babf6b0$export$a0a76643dec233ef {
    static init(url, loginData, serverConfig, connectionStateHandler) {
        return $263e32773babf6b0$var$__awaiter(this, void 0, void 0, function*() {
            const client = new (0, $hgUW1$DeepstreamClient)(url);
            const response = yield client.login(loginData);
            this.serverHandlerInstance = new (0, $588d53c9d0a3fe05$export$158274cca421e33f)(client, serverConfig, connectionStateHandler);
            yield this.serverHandlerInstance.init();
            this.eventsHandlerInstance = new (0, $4cd3b7212bcaccc8$export$d85660bfa2d43d55)(client);
            this.meetingsHandlerInstance = new (0, $917eb34e2ff5fad2$export$3da1b1fa9b85532a)(client);
            return response;
        });
    }
    static get meetingsHandler() {
        if (!this.meetingsHandlerInstance) throw new Error("You must call init() before accessing meetingsHandler");
        return this.meetingsHandlerInstance;
    }
    static get eventsHandler() {
        if (!this.eventsHandlerInstance) throw new Error("You must call init() before accessing eventsHandler");
        return this.eventsHandlerInstance;
    }
    static get serverHandler() {
        if (!this.serverHandlerInstance) throw new Error("You must call init() before accessing serverHandler");
        return this.serverHandlerInstance;
    }
}


$parcel$exportWildcard($b7e00d9222920261$exports, $3e7eb75c2c460d38$exports);
$parcel$exportWildcard($b7e00d9222920261$exports, $263e32773babf6b0$exports);


window.Buffer = window.Buffer || (0, $hgUW1$Buffer);


export {$3e7eb75c2c460d38$export$4835bcdedd18ae83 as CenoraInternalCommunication, $263e32773babf6b0$export$a0a76643dec233ef as CenoraRealtimeCommunication};
//# sourceMappingURL=module.js.map
